import React from 'react';
import { motion } from 'framer-motion';
export function Hero() {
  return <section className="relative pt-32 pb-20 lg:pt-48 lg:pb-32 bg-halftone-blue overflow-hidden" data-id="element-57">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-58">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center" data-id="element-59">
          <motion.div initial={{
          opacity: 0,
          x: -50
        }} animate={{
          opacity: 1,
          x: 0
        }} transition={{
          duration: 0.6
        }} className="text-center lg:text-left" data-id="element-60">
            <div className="inline-block mb-4 bg-[#FFD700] text-black font-bangers text-xl px-4 py-1 comic-border rotate-[-2deg]" data-id="element-61">
              NEW RELEASE!
            </div>
            <h1 className="font-bangers text-6xl sm:text-7xl lg:text-8xl text-white text-stroke-black italic leading-[1.1] mb-6" data-id="element-62">
              Turn Your Photos Into Epic Comics
            </h1>
            <p className="text-white text-lg sm:text-xl font-bold mb-8 max-w-2xl mx-auto lg:mx-0 drop-shadow-md bg-black/20 p-4 rounded-xl backdrop-blur-sm comic-border" data-id="element-63">
              Create comics, manga & webtoons with your own characters. Just
              upload a photo, write a prompt, and watch the magic happen.
            </p>
            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start space-y-4 sm:space-y-0 sm:space-x-6" data-id="element-64">
              <a href="https://apps.apple.com/us/app/comicut/id6761404605" target="_blank" rel="noopener noreferrer" className="w-full sm:w-auto bg-black text-white font-bangers text-2xl px-8 py-4 comic-border border-white comic-shadow hover:translate-y-1 hover:translate-x-1 hover:shadow-none transition-all flex items-center justify-center gap-2" data-id="element-65">
                App Store
              </a>
              <span className="w-full sm:w-auto bg-gray-400 text-gray-700 font-bangers text-2xl px-8 py-4 comic-border border-gray-500 flex items-center justify-center gap-2 cursor-not-allowed opacity-70" data-id="element-66">
                Google Play — Coming Soon
              </span>
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 100,
          rotate: 0
        }} animate={{
          opacity: 1,
          y: 0,
          rotate: -5
        }} transition={{
          duration: 0.8,
          type: 'spring'
        }} className="relative mx-auto w-full max-w-[320px] sm:max-w-[380px]" data-id="element-67">
            {/* Decorative elements */}
            <div className="absolute -top-12 -right-12 bg-[#FFD700] text-black font-bangers text-3xl p-4 rounded-full comic-border comic-shadow z-20 rotate-12 animate-bounce" data-id="element-68">
              POW!
            </div>
            <div className="absolute -bottom-8 -left-8 bg-white text-black font-bangers text-2xl p-3 rounded-full comic-border comic-shadow z-20 -rotate-12" data-id="element-69">
              BAM!
            </div>

            {/* Phone Mockup */}
            <div className="relative rounded-[2.5rem] comic-border bg-black p-2 comic-shadow z-10" data-id="element-70">
              <div className="rounded-[2rem] overflow-hidden bg-white relative" data-id="element-71">
                <img src="https://cdn.magicpatterns.com/uploads/gdFdN6VWusQza8AhWJJvaw/0x0ss_(9).png" alt="Comicut App Screenshot" className="w-full h-auto object-cover" data-id="element-72" />
              </div>
            </div>
          </motion.div>
        </div>
      </div>

      {/* Background decorative action lines */}
      <div className="absolute top-0 left-0 w-full h-full pointer-events-none overflow-hidden z-0 opacity-20" data-id="element-73">
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[200%] h-[200%] bg-[conic-gradient(from_0deg,transparent_0deg,white_10deg,transparent_20deg,white_30deg,transparent_40deg,white_50deg,transparent_60deg,white_70deg,transparent_80deg,white_90deg,transparent_100deg,white_110deg,transparent_120deg,white_130deg,transparent_140deg,white_150deg,transparent_160deg,white_170deg,transparent_180deg,white_190deg,transparent_200deg,white_210deg,transparent_220deg,white_230deg,transparent_240deg,white_250deg,transparent_260deg,white_270deg,transparent_280deg,white_290deg,transparent_300deg,white_310deg,transparent_320deg,white_330deg,transparent_340deg,white_350deg,transparent_360deg)]" data-id="element-74"></div>
      </div>
    </section>;
}